module.exports = __webpack_public_path__ + "static/media/neo.37354c36.png";